import { useState, useEffect } from 'react';
import { apiClient } from '@/utils/api';

interface GeneralSettings {
  companyName: string;
  timezone: string;
  language: string;
}

interface AppSettings {
  general: GeneralSettings;
}

export function useSettings() {
  const [settings, setSettings] = useState<AppSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [settingsKey, setSettingsKey] = useState(0);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        // Force refresh se c'è un timestamp di invalidazione
        const invalidateTimestamp = localStorage.getItem('settings:invalidate');
        const response = await apiClient.get('/settings', {
          params: invalidateTimestamp ? { _t: invalidateTimestamp } : {}
        });
        setSettings(response.data);
        setError(null);
        // Rimuovi il flag di invalidazione dopo il fetch
        if (invalidateTimestamp) {
          localStorage.removeItem('settings:invalidate');
        }
      } catch (err: any) {
        console.error('Error fetching settings:', err);
        setError(err.response?.data?.message || 'Errore nel caricamento delle impostazioni');
        // Fallback settings
        setSettings({
          general: {
            companyName: 'Studio Gori',
            timezone: 'Europe/Rome',
            language: 'it'
          }
        });
      } finally {
        setLoading(false);
      }
    };

            const handleSettingsChanged = () => {
              console.log('Settings changed event received, refetching...');
              setRefreshKey(prev => prev + 1);
              setSettingsKey(prev => prev + 1);
              fetchSettings();
            };

    fetchSettings();
    
    // Aggiungi event listener per refresh immediato
    window.addEventListener('settings:changed', handleSettingsChanged);
    return () => window.removeEventListener('settings:changed', handleSettingsChanged);
  }, []); // Dipendenza vuota, refresh solo on mount

  return { settings, loading, error, refreshKey, settingsKey };
}
